<template>
  <v-container class="cmpbk black--text" id="home-container">
    <!--//@*/*
    //    *RPD  App v0.91
    //    * Copyright (c) 2025, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->
   <template>
      <div style="width:100%;background-color: rgb(48, 48, 48);"> 
    <h2 class="ml-4 white--text" style="width:100%;background-color: rgb(48, 48, 48);">Register</h2>
    <hr>
  </div>
    <v-stepper v-model="steep" alt-labels :mobile="false" id="stepper" >
    <v-stepper-header>
      <v-stepper-step
        :complete="steep > 1"
        step="1"
      >
        Fill in Form
      </v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step
        :complete="steep > 2"
        step="2"
      >
        Security Question
      </v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step step="3">
       Create Password
      </v-stepper-step>
    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content step="1">
        <v-card>
          <template>
            <v-form
       
            dark
              ref="form"
              v-model="valid"
              lazy-validation
            >
      <v-row dense>
          <v-col cols="12" md="3">
            <v-text-field
                dense         
         
                maxlength="60"
                color="grey lighten-2"
                class="mt-3 mb-0 mx-1"
                dark
                v-model="vm_regevent.fname"
                :rules="reqRules60"
                label="First Name"
                required
                outlined
                counter="60"
              ></v-text-field>
              
            </v-col>
            <v-col cols="12" md="3">
            <v-text-field
                dense         
              
                maxlength="60"
                color="grey lighten-2"
                class="mt-3 mb-0 mx-1"
                dark
                v-model="vm_regevent.lname"
                :rules="reqRules60"
                label="Last Name"
                required
                outlined
                counter="60"
              ></v-text-field>
              
            </v-col>
          <v-col cols="12" md="3">
            <v-text-field
                dense
                maxlength="120"
                color="grey lighten-2"
                    class="mt-3 mb-0 mx-1"
                dark
                v-model="vm_regevent.email"
                :rules="reqRules120"
                label="Email"
                required
                outlined
                counter="120"
              ></v-text-field>
              
            </v-col>
            <v-col cols="12" md="3">
            <v-text-field
         dense
              maxlength="10"
              color="grey lighten-2"
                 class="mt-3 mb-0 mx-1"
              dark
              v-model="vm_regevent.dob"
              label="DOB (MM/DD/YYYY)"
              prepend-inner-icon="$calendar"
              :rules="[dateWithinCentury]"
              required
              outlined
              v-mask="'##/##/####'"
              >
            </v-text-field>
            </v-col>
          </v-row>
            <h5 class="ml-2">Please write security questions and answers. They should 
            be simple and known only to you. For example, 
            "Favorite Show?," "Love Boat," "Milk or Dark Chocolate?,""Dark."</h5>

      <v-row dense>
          <v-col cols="12" md="6">
        <v-text-field
            maxlength="200"
                color="grey lighten-2"
                  class="mt-3 mb-0 mx-1"
                dark
                v-model="vm_regevent.question1"
                :rules="reqRules200"
                label="Security Question 1"
                required
                outlined
                counter="200"
              ></v-text-field>
          </v-col>
        <v-col cols="12" md="6">
        <v-text-field
            maxlength="200"
                color="grey lighten-2"
                    class="mt-3 mb-0 mx-1"
                dark
                v-model="vm_regevent.answer1"
                :rules="reqRules200"
                label="Answer 1"
                required
                outlined
                counter="200"
              >
            </v-text-field>
          </v-col>
          </v-row>
      <v-row dense>
          <v-col cols="12" md="6">
        <v-text-field
            maxlength="200"
                color="grey lighten-2"
                  class="mt-3 mb-0 mx-1"
                dark
                v-model="vm_regevent.question2"
                :rules="reqRules200"
                label="Security  Question 2"
                required
                outlined
                counter="200"
              ></v-text-field>
          </v-col>
        <v-col cols="12" md="6">
        <v-text-field
            maxlength="200"
                color="grey lighten-2"
                    class="mt-3 mb-0 mx-1"
                dark
                v-model="vm_regevent.answer2"
                :rules="reqRules200"
                label="Answer 2"
                required
                outlined
                counter="200"
              >
            </v-text-field>
          </v-col>
          </v-row>
            </v-form>
          </template
    > 
    <v-row dense>
  <v-col cols="12" md="3" sm="3" >
  <v-btn
    class="mt-4 ml-1 ca-btn"
    color="primary"
    @click="saveRegEvent"
    >
    Continue
  </v-btn>
</v-col>
  <v-col cols="12" md="3" sm="3" >
    <v-btn
    class="mt-4 ml-1 mb-2 ca-btn"
    color="primary"
    @click="cancel"
    >
    Cancel
    </v-btn>
</v-col>

</v-row>
  </v-card>


      </v-stepper-content>

<v-stepper-content step="2">
  
<v-card style="width:100%;background-color: rgb(48, 48, 48);" >
  <template>
    <p>
        A code has been sent to the email you supplied. To validate your ownership, 
        please go to your email now, retrieve the code, and place it in the text field below.</p>
    <p><b><i>{{question}}</i></b></p>
  

    <v-form
      style="height: auto"
      dark
      ref="form2"
      v-model="valid2"
      lazy-validation
    >
  <!-- :append-icon="showeye ? 'mdi-eye-off' : 'mdi-eye'"  style="position: relative;top: -91px; left: 911px;" -->
        <v-text-field
          required
          type="number"
          color="grey lighten-2"
          class="mt-4 mb-4 pa-1"

          v-model="code"

          label="Code"
          clearable
          outlined        
      ></v-text-field> 

    </v-form>
  <v-row dense>
      <v-col cols="12" md="3" sm="3" >
      <v-btn
      class="pa-2 mt-4 ca-btn"
      color="primary"
      @click="submit_code"
      >
      Submit Code
      </v-btn>
    </v-col>
    <v-col cols="12" md="3" sm="3" >
      <v-btn  class="pa-2 mt-4 ca-btn"  @click="send_new_code" >
      Send New Code
      </v-btn>
    </v-col>
    <v-col cols="12" md="3" sm="3" >
      <v-btn  class="pa-2 mt-4 ca-brn"  @click="steep=1" >
      Back
      </v-btn>
    </v-col>
      <v-col cols="12" md="3" sm="3" >
        <v-spacer></v-spacer>
      </v-col>
  </v-row>



  </template>
        </v-card>


      </v-stepper-content>

      <v-stepper-content step="3" >
        <v-card
        dark>
           <v-card-text dark>
      <h4>Now its time to create your RPD Portal compliant password.
          This password must be at least 8 characters in length and
          contain at least (1) Upper Case Letter + (1) Lower Case Letter + (1) Number and (1) Symbol !@@#$%^&.</h4>    
    
    <v-form
      style="height: auto;"
      dark
      ref="form3"
      v-model="valid3"
      lazy-validation
    ><v-row dense>
      <v-col cols="12" md="6" >        <v-text-field
          required
          color="grey lighten-2"
          class="mt-4 mb-4 pa-1"
        :append-icon="showeye ? `$eyeoff` : `$eye`" 
        @click:append="toggle_eye"
        :type="showeye ? 'text' : 'password'"
          v-model="password"
          :rules="passwordRules"
          label="Password"
          clearable
          outlined        
      ></v-text-field> </v-col>
       <v-col cols="12" md="6" >   
        <v-text-field
        required
        color="grey lighten-2"
        class="mt-4 mb-4 pa-1"
        :append-icon="showeye ? `$eyeoff` : `$eye`" 
        @click:append="toggle_eye"
        :type="showeye ? 'text' : 'password'"
        v-model="password2"

        label="Match password"
        clearable
        outlined        
        ></v-text-field> 
    </v-col>
    </v-row>
  <!-- :append-icon="showeye ? 'mdi-eye-off' : 'mdi-eye'"  style="position: relative;top: -91px; left: 911px;" -->


    </v-form>
        </v-card-text>
        <v-card-actions>  
          <v-row dense>
             <v-col cols="12" md="3" sm="3" >
        <v-btn  class="mt-4 ca-btn"    color="primary"  @click="save_password">
          Submit Password
        </v-btn>
             </v-col>
             <v-col cols="12" md="3" sm="3" >
          <v-btn text class="mt-4 white--text ca-btn"      @click="steep = 2">
            Back
          </v-btn>
             </v-col>
          </v-row>


      </v-card-actions>
      </v-card>



      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
   </template>
  </v-container>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";
::v-deep .theme--dark input[type='date']::-webkit-calendar-picker-indicator,
::v-deep .theme--dark input[type='date']::-moz-calendar-picker-indicator {
  filter: brightness(0) invert(1);   /* flip black → white */
  opacity: 1;                        /* fixes Safari */
}
.theme--dark input[type='date'] {
  color-scheme: dark;   /* new CSS property */
}
.grow-stepper .v-stepper__wrapper,
.grow-stepper .v-stepper__items {
  height: auto !important;     /* remove the inline 160 px */
}
.grow-stepper .v-stepper__content {
  max-height: none !important; /* kill the default 600 px cap */
}
.ca-btn{
  width:100%;
}
@media (min-width: 768px) {
  
.ca-btn{
  width: 170px;
  }
}
</style>

<script>
/* eslint-disable */
/* global document */
import { bus_common } from "../mixins/bus_common";
export default {
  name: "register",
  mixins: [bus_common],
  data() {
        const pwdRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*]).{8,}$/;
    return {
      regevent_live:{},
      regcode:"",
      vm_regevent: {
        regeventId: 0,
        status: 'Baby record',
        code: 0,
        codeDT: '1/1/1900',
        dob: '',
        dob_valid: false,
        email: '',
        email_valid: false,
        phone: '',
        phone_valid: false,
        guest_email: '',
        password: '',
        fname: '',
        fname_valid: false,
        lname: '',
        lname_valid: false,
        badge: '',
        useragent: '',
        ip: '',
        question1: '',
        question1_valid: false,
        answer1: '',
        answer1_valid: false,
        question2: '',
        question2_valid: false,
        answer2: '',
        answer2_valid: false,
        agency: '',
        supervisorName: '',
        supervisorEmail: '',
        s_del: '',
        s_user: '',
        s_CreateDate: '',
        s_date: ''
      },
      showeye:false,
      code:"",
      cnt:1,
      valid3:"",
      answer:"",
      question:"",
      showeye:false,
      password2:"",
      password:"",
      valid2:true,
      valid:true,
      email: '',
      reqRules200: [
        v => !!v || 'Field is required',
        v => v.length <= 200 || 'Name must be less than 200 characters',
      ],
            reqRules120: [
        v => !!v || 'Field is required',
        v => v.length <= 120 || 'Name must be less than 120 characters',
      ],
      reqRules60: [
        v => !!v || 'Field is required',
        v => v.length <= 60 || 'Name must be less than 60 characters',
      ],
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      passwordRules: [
        v => !!v || 'Password is required',
        v => pwdRegex.test(v) ||
              'Min 8 · 1 upper · 1 lower · 1 digit · 1 symbol (!@#$%^&*)'
      ],
      steep: 1,
    }
  },
  methods: {
    //save_password
     save_password() {
       console.log("save_password", this.password, this.regevent_live);

      this.show_loader(true);
      var formIn = {};
      formIn.check =this.mno(this.password);
      formIn.regeventId = this.mno(this.regevent_live);

      formIn.apiname = "save_password";
      
      var self = this;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(false);
          try {

            if(data.msg.indexOf("Regevents") > -1) {
              this.swall_it("Save Password",  data.msg, "warning", null, null);
              return true;
            }
            if(data.msg.indexOf("Server error") > -1) {
              this.swall_it("Save Password",  "Server error", "error", null, null);
              return true;
            }
        
          console.log('Result:', result)
          } catch (error) {
          // Runs only if an error occurs in try block
           console.error('Something went wrong:', error.message)
          }

          //sucess
          this.swall_it("Save Password", "Success. Please log in.", "success", null, null);
       self.$emit("register_quit");
  
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error Save", msg, "error", null, null);
        });
    },
    //send_new_code
     send_new_code() {
       console.log("send_new_code");

      this.show_loader(true);
      var formIn = {};
      formIn.code = this.mno(this.regcode);
      formIn.email = this.mno(this.vm_regevent.email);

      formIn.apiname = "send_new_code";
      
      var self = this;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(false);
          try {
         
            if(data.msg.indexOf("could not be found.") > -1) 
            {
             this.swall_it("Send New Code Status",  data.msg + " Go back and start registration over.", "warning", null, null);
            return true;
            }

          //sucess
          self.regcode = data.msg;
          this.swall_it("Send New Code", "Success. Check Email", "success", null, null);
       
      } catch (error) {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error Send", msg, "error", null, null);
          }
     
      });
    },
    //submit_code
    submit_code() {
       console.log("submit_code");

      this.show_loader(true);
      var formIn = {};
      formIn.code =this.mno(this.code);
      formIn.email = this.mno(this.vm_regevent.email);

      formIn.apiname = "submit_code";
      
      var self = this;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(false);
          try {
          // Code that might throw an error
          //Code not found
            if(data.msg.indexOf("Code not found") > -1) {
             this.swall_it("Save Status",  data.msg, "warning", null, null);
            return true;
          }
          console.log('Result:', result)
          } catch (error) {
          // Runs only if an error occurs in try block
           console.error('Something went wrong:', error.message)
          }

          //sucess
          self.regevent_live =  self.mno(data);
          this.swall_it("Submit Code", "Success", "success", null, null);
          self.steep = 3;
  
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error Save", msg, "error", null, null);
        });
    },
     dateWithinCentury (value) {
      // 1) quick format test  (MM/DD/YYYY)
      if (!/^\d{2}\/\d{2}\/\d{4}$/.test(value))
        return 'Use MM/DD/YYYY format'

      // 2) parse pieces
      const [mm, dd, yyyy] = value.split('/').map(Number)

      // month is 0-based in JS Date
      const asDate = new Date(yyyy, mm - 1, dd)

      // 3) reject impossible calendar dates (e.g. 02/31/2024)
      if (
        asDate.getFullYear() !== yyyy ||
        asDate.getMonth()     !== mm - 1 ||
        asDate.getDate()      !== dd
      )
        return 'Not a valid calendar date'

      // 4) range check: today … today-100y
      const today          = new Date()
      const hundredAgo     = new Date(today.getFullYear() - 100,
                                      today.getMonth(),
                                      today.getDate())

      if (asDate > today)
        return 'Date can’t be in the future'

      if (asDate < hundredAgo)
        return 'Must be within the last 100 years'

      // all good
      return true
    },
toggle_eye(){
  this.showeye=!this.showeye;
},

 saveRegEvent() {
       console.log("saveRegEvent");

      this.show_loader(true);
      var formIn = {};
      formIn.vm_regevent =this.mno(this.vm_regevent);
      var useragent = window.navigator.userAgent;
      formIn.vm_regevent.useragent = useragent;
      formIn.vm_regevent.dob =  this.format_date_sql(new Date(this.vm_regevent.dob));

      formIn.apiname = "saveRegEvent";
      var self = this;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(false);
        //  self.mrbreakpoint("save");
          if(data.msg.indexOf("previously") > -1) {
            this.swall_it("Save Status",  data.msg, "warning", null, null);
            return true;
          }
           //Server error
          if(data.msg.indexOf("Server error") > -1) {
            this.swall_it("Save Status",  data.msg, "error", null, null);
            return true;
          }
         self.regcode = data.msg;
          //sucess
          this.swall_it("Save Status", "Success", "success", null, null);
          self.steep = 2;
  
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error Save", msg, "error", null, null);
        });
    },
  setNewPassword() {
       console.log("submit_password");

      if (this.password != this.password2) {
              this.swall_it("Password Status", "Passwords must match.", "warning", null, null);
              return true
      }
      this.show_loader(true);
      var formIn = {};
      formIn.count = parseInt( this.code);
      formIn.check = this.password;

      formIn.apiname = "setNewPassword";
      var self = this;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
                    this.show_loader(false);

          if (data.msg.indexOf("Your email was not found") > -1) {
                      this.swall_it("Password Status", "Your email was not found.  Password not set.", "error", null, null);
                      self.cnt++;
                      return true;
          }
                    if (data.msg.indexOf("Server error") > -1) {
                      this.swall_it("Password Status", "Server error. Password not set. Please try again.", "error", null, null);
                      self.cnt++;
                      return true;
          }
          //sucess
           this.swall_it("Password Status", "Password saved. Use your email and your password to log in.", "success", null, null);

              this.$emit('register_quit');

  
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error Answer", msg, "error", null, null);
        });
    },
  submit_answer() {
       console.log("submit_answer");


      this.show_loader(true);
      var formIn = {};
      formIn.email = this.email;
      formIn.answer = this.answer;

      formIn.apiname = "submit_answer";
      var self = this;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
                    this.show_loader(false);
          if (self.cnt == 3) {
                this.swall_it("Email Status", "You have exceeded the number of tries to answer a security question. Reload this page to try again.", "warning", null, null);
                self.steep = 1;

            return true;
          }
          if (data.msg.indexOf("incorrect") > -1) {
                      this.swall_it("Email Status", "Unfortunately, your answer to the security question is incorrect. You are allowed three tries.", "warning", null, null);
                      self.cnt++;
                      return true;
          }else{
            self.code = self.mno(data.msg);
            self.steep = 3;
          }

  
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error Answer", msg, "error", null, null);
        });
    },
  submit_email_recover() {
       console.log("submit_email_recover");
      this.show_loader(true);
      var formIn = {};
      formIn.email = this.email;


      formIn.apiname = "submit_email_recover";
      var self = this;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
                    this.show_loader(false);
          if (data.msg.indexOf("not found") > -1) {
                this.swall_it("Email Status", "Email not found. Please register.", "warning", null, null);
                return true;
          }else{
            self.question = self.mno(data.msg);
            self.steep = 2;
          }

  
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error Email", msg, "error", null, null);
        });
    },
    cancel(){
      this.$emit('reg_quit');
    },
    checkemail() {
       console.log("checkmail");


      this.show_loader(true);
      var formIn = {};
      formIn.email = this.email;

      formIn.apiname = "checkemail";
      var self = this;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
                    this.show_loader(false);
          if (data.msg == "found") {
                    self.steep = 2;
          }else{
           this.swall_it("Email Status", "Enail not found. Please register.", "warning", null, null);
          }

  
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error Email", msg, "error", null, null);
        });
    },
    message1() {
      alert("This button does nothing yet.");
    },
    init() {},
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
